const request = require('../../../../src/lib/http-caller')(`${process.env.VUE_APP_API_GATEWAY_URL}`)
const { RestError } = require('../../../../src/lib/errors')

const get = async (path, jwt) => {
  return await makeRequest(request.get({ url: path, json: true, auth: { bearer: jwt } }))
}

const post = async (path, jwt, payload) => {
  return await makeRequest(request.post({ url: path, json: true, body: payload, auth: { bearer: jwt } }))
}

const put = async (path, jwt, payload) => {
  try {
    return await makeRequest(request.put({ url: path, json: true, body: payload, auth: { bearer: jwt } }))
  } catch (error) {
    throw error
  }
}

const del = async (path, jwt) => {
  return await makeRequest(request.del({ url: path, json: true, auth: { bearer: jwt } }))
}

const makeRequest = async (fn) => {
  const response = await fn
  if (response.body && response.body.error) throw new RestError(response.body.status, response.body.message, response.body.statusDetail)
  return response
}

module.exports = {
  get,
  post,
  put,
  delete: del
}
